module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold.c37119ff.woff";